import React, { useContext, useState, useEffect } from "react";
import { LoanFormContext } from "./LoanForm";
import FormStep from "../../FormStep";
import { Button, Form, InputGroup } from "react-bootstrap";
import { InputError } from "../Controls";
import validator from "validator";

const Email: React.FunctionComponent<{
  onSubmit?: (value: string) => void;
}> = (props: { onSubmit?: (value: string) => void }) => {
  const loanFormContext = useContext(LoanFormContext);
  const [email, setEmail] = useState<string>(
    loanFormContext.email ? loanFormContext.email : ""
  );
  const [emailError, setEmailError] = useState<InputError>({
    error: "",
    touched: false,
  });

  useEffect(() => {
    if (!validator.isEmail(email)) {
      setEmailError({
        ...emailError,
        error: "Please enter a valid email address.",
      });
    } else {
      setEmailError({ ...emailError, error: "" });
    }
  }, [email]);

  const handleSubmit = () => {
    if (!emailError.error) {
      if (props.onSubmit) props.onSubmit(email);
    } else {
      setEmailError({ ...emailError, touched: true });
    }
  };

  return (
    <div>
      <FormStep header={<h1 className="heading-main">What is your email?</h1>}>
        <div className="form-inputs-wrapper">
          <Form.Group>
            <label>
              <InputGroup className="mb-3">
                <InputGroup.Prepend>
                  <InputGroup.Text id="basic-addon1">
                    {/* <i
                    className="icofont-ui-email"
                    style={{ fontSize: "1.25rem", color: "#069059" }}
                  ></i> */}
                    <span style={{ fontWeight: 900 }}>@</span>
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setEmail(e.target.value)
                  }
                  onBlur={() => {
                    setEmailError({ ...emailError, touched: true });
                  }}
                  tabIndex={0}
                />
              </InputGroup>
            </label>
            {emailError && emailError.touched && (
              <div className="hint text-danger">{emailError.error}</div>
            )}
            {!emailError.error && !emailError.error && (
              <div className="hint">
                (We take privacy seriously, For more information about our
                privacy policy,{" "}
                <a
                  href="https://neighborhoodloans.com/privacy-policy/"
                  target="_blank"
                  rel="noreferrer"
                >
                  click here
                </a>
                )
              </div>
            )}
          </Form.Group>
          <div className="mt-5">
            <Button variant="primary" block onClick={handleSubmit} tabIndex={0}>
              Continue
            </Button>
          </div>
        </div>
      </FormStep>
    </div>
  );
};

export default Email;
